const symbols = {
    ln: [
        {
            type: 'log-start',
            text: 'ln(',
            start: 'np.log(',
            end: ')',
            display: 'ln'
        }
    ],
    sqrt: [
        {
            type: 'sqrt-start',
            text: 'sqrt(',
            start: 'np.sqrt(',
            end: ')',
            display: '&Sqrt;'
        }
    ],
    lag: [
        {
            type: 'lag-start',
            text: 'lag(',
            start: '(',
            end: ').shift(1)',
            display: 'lag'
        }
    ],
    exp: [
        {
            type: 'exp',
            text: 'exp(',
            start: 'np.exp(',
            end: ')',
            display: 'exp'
        }
    ],
    pow2: [
        {
            type: 'pow2',
            text: 'pow2(',
            niceStart: '(',
            niceEnd: ')<sup>2</sup>',
            start: 'np.power(',
            end: ',2)',
            display: 'x<sup>2</sup>'
        }
    ],
    pow3: [
        {
            type: 'pow3',
            text: 'pow3(',
            niceStart: '(',
            niceEnd: ')<sup>3</sup>',
            start: 'np.power(',
            end: ',3)',
            display: 'x<sup>3</sup>'
        }
    ],
    parenthesisRight: [
        {
            type: 'p-end',
            text: ')',
            start: ')',
            display: ')'
        }
    ],
    parenthesisLeft: [
        {
            type: 'p-start',
            text: '(',
            start: '(',
            end: ')',
            display: '('
        }
    ],
    plus: [
        {
            type: 'plus',
            text: '+',
            start: '+',
            display: '+'
        }
    ],
    minus: [
        {
            type: 'minus',
            text: '-',
            start: '-',
            display: '-'
        }
    ],
    multiplier: [
        {
            type: 'multiplier',
            text: 'x',
            start: '*',
            display: 'x'
        }
    ],
    divider: [
        {
            type: 'divider',
            text: '/',
            start: '/',
            display: '/'
        }
    ],
    dot: [
        {
            type: 'dot',
            text: '.',
            start: '.',
            display: '.'
        }
    ],
    zero: [
        {
            type: 'zero',
            text: '0',
            start: '0',
            display: '0'
        }
    ],
    one: [
        {
            type: 'one',
            text: '1',
            start: '1',
            display: '1'
        }
    ],
    two: [
        {
            type: 'two',
            text: '2',
            start: '2',
            display: '2'
        }
    ],
    three: [
        {
            type: 'three',
            text: '3',
            start: '3',
            display: '3'
        }
    ],
    four: [
        {
            type: 'four',
            text: '4',
            start: '4',
            display: '4'
        }
    ],
    five: [
        {
            type: 'five',
            text: '5',
            start: '5',
            display: '5'
        }
    ],
    six: [
        {
            type: 'six',
            text: '6',
            start: '6',
            display: '6'
        }
    ],
    seven: [
        {
            type: 'seven',
            text: '7',
            start: '7',
            display: '7'
        }
    ],
    eight: [
        {
            type: 'eight',
            text: '8',
            start: '8',
            display: '8'
        }
    ],
    nine: [
        {
            type: 'nine',
            text: '9',
            start: '9',
            display: '9'
        }
    ]
};

const numbers = {};

export const ItemTypes = {
    CARD: 'card',
    NUMBER: numbers,
    SYMBOL: symbols
};
